var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "checkout-form-group__fields checkout-form-group__fields--corporate",
    },
    [
      _c("div", { staticClass: "row checkout-form-group__row-fields" }, [
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [_vm._v("ИНН*")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.inn,
                      expression: "order.inn",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.inn },
                  attrs: { type: "text" },
                  domProps: { value: _vm.order.inn },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "inn", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.inn
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " + _vm._s(_vm.errors.inn.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [
                _vm._v("Название компании*"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.company_name,
                      expression: "order.company_name",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.company_name },
                  attrs: { type: "text" },
                  domProps: { value: _vm.order.company_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "company_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.company_name
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.errors.company_name.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [
                _vm._v("Юридический адрес"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.company_address,
                      expression: "order.company_address",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.company_address },
                  attrs: { type: "text" },
                  domProps: { value: _vm.order.company_address },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.order,
                        "company_address",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.company_address
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.errors.company_address.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [_vm._v("КПП")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.company_kpp,
                      expression: "order.company_kpp",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.company_kpp },
                  attrs: { type: "text" },
                  domProps: { value: _vm.order.company_kpp },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "company_kpp", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.company_kpp
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.errors.company_kpp.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [_vm._v("Имя*")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.first_name,
                      expression: "order.first_name",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.first_name },
                  attrs: { type: "text" },
                  domProps: { value: _vm.order.first_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "first_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.first_name
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.errors.first_name.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [
                _vm._v("Отчество"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.third_name,
                      expression: "order.third_name",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.third_name },
                  attrs: { type: "text" },
                  domProps: { value: _vm.order.third_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "third_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.third_name
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.errors.third_name.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [
                _vm._v("Фамилия"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.second_name,
                      expression: "order.second_name",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.second_name },
                  attrs: { type: "text" },
                  domProps: { value: _vm.order.second_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "second_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.second_name
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.errors.second_name.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [
                _vm._v("Телефон*"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.phone,
                      expression: "order.phone",
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "+7(###)###-##-##",
                      expression: "'+7(###)###-##-##'",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.phone },
                  attrs: { placeholder: "+7(xxx)xxx-xx-xx", type: "text" },
                  domProps: { value: _vm.order.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "phone", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.phone
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " + _vm._s(_vm.errors.phone.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6 col-xl-4" }, [
          _c(
            "div",
            { staticClass: "form-group checkout-form-group__field-group" },
            [
              _c("div", { staticClass: "form-group__label" }, [
                _vm._v("Email*"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group__field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.order.email,
                      expression: "order.email",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.email },
                  attrs: { type: "email" },
                  domProps: { value: _vm.order.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.order, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.email
                  ? _c("p", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        "\n              " + _vm._s(_vm.errors.email.join(", "))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group checkout-form-group__field-group" },
        [
          _c("div", { staticClass: "form-group__label" }, [
            _vm._v("Комментарий"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group__field" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.order.comment,
                  expression: "order.comment",
                },
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.errors.comment },
              domProps: { value: _vm.order.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.order, "comment", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.errors.comment
              ? _c("p", { staticClass: "invalid-feedback" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.comment.join(", "))
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }